// extracted by mini-css-extract-plugin
export default {"descriptionEdit":"description-edit_descriptionEdit__0c3tb","fieldset":"description-edit_fieldset__X0JTv","inputGroupStyle":"description-edit_inputGroupStyle__ZR7Tw"};